module.exports = __webpack_public_path__ + "static/img/icon_m_close.5baffdba.svg";